import { Injectable } from "@angular/core";

@Injectable()
export class PagesList {
    public static LIST_BENEFICIARY = 'LIST-BENEFICIARY';
    public static REMITTANCE_STEPPER = 'REMITTANCE-STEPPER';
}